export default "__VITE_ASSET__0850d050__"